<template>
    <b-form class="login-form" @submit.prevent="onSubmit">
        <b-alert
            :variant="formAlertType"
            show
            v-if="!formState.processing && formState.message.length > 0"
        >
            {{ formState.message }}
        </b-alert>

        <b-form-group label="Login or Email address">
            <b-form-input
                v-model.trim="formData.login"
                type="text"
                :state="loginValid"
            />
            <b-form-invalid-feedback :state="loginValid">
                {{ formValidation.login }}
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Password">
            <b-form-input
                v-model.trim="formData.password"
                type="password"
                :state="passwordValid"
            />
            <b-form-invalid-feedback :state="passwordValid">
                {{ formValidation.password }}
            </b-form-invalid-feedback>
        </b-form-group>

        <b-button
            type="submit"
            variant="primary"
            block
            class="login-submit"
            :disabled="formState.processing"
        >
            {{ !formState.processing ? "Login" : "Processing..." }}
        </b-button>
    </b-form>
</template>

<script>
import { mapActions } from "vuex";
import { API_ROUTES } from "../api";

const USER_APP_URL = process.env.MIX_USER_APP_URL;

export default {
    computed: {
        formAlertType: function () {
            return this.formState.success ? "success" : "danger";
        },
        loginValid: function () {
            return this.formValidation.login.length > 0 ? false : null;
        },
        passwordValid: function () {
            return this.formValidation.password.length > 0 ? false : null;
        },
    },
    data() {
        return {
            formData: {
                login: "",
                password: "",
            },
            formValidation: {
                login: "",
                password: "",
            },
            formState: {
                success: null,
                message: "",
                processing: false,
            },
        };
    },
    methods: {
        ...mapActions({
            login: "auth/login",
        }),
        onSubmit() {
            this.formState.processing = true;
            for (let fieldName in this.formValidation) {
                this.formValidation[fieldName] = "";
            }
            const loginRoute = process.env.MIX_AUTH_MODE === 'auth0' ? 'LOGIN_AUTH0' : 'LOGIN';
            this.$api
                .post(API_ROUTES[loginRoute], this.formData)
                .then(({ data }) => {
                    this.formState.success = true;
                    this.formState.message =
                        "You have been successfully logged in";
                    this.login(data);
                    if (!data.user.role || data.user.role.code !== "admin") {
                        window.location.href = USER_APP_URL;
                    } else {
                        this.$router.replace({ name: "admin-dashboard" });
                    }
                })
                .catch(({ response: { data } }) => {
                    this.formState.success = false;
                    if (typeof data.errors !== "undefined") {
                        for (let fieldName in this.formValidation) {
                            if (typeof data.errors[fieldName] !== "undefined") {
                                this.formValidation[fieldName] =
                                    data.errors[fieldName].join(", ");
                            }
                        }
                    }
                    if (typeof data.message !== "undefined") {
                        this.formState.message = data.message;
                    }
                })
                .finally(() => {
                    this.formState.processing = false;
                });
        },
    },
};
</script>
